import { Injectable } from '@angular/core';
import { UtilsService } from '@core/services/utils/utils.service';
import { dwnldPDFType, dwnldCSVType } from '@core/services/utils/uitils.types';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { vGlobal } from '@core/types/cb-global-vars';
@Injectable({ providedIn: 'root' })
export class DownloadReportService {
  // -----------------------------------------------------------------------------------------------------
  // @ Decorators
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Public declaration vars
  // -----------------------------------------------------------------------------------------------------
  nav: any = window.navigator as any;
  // -----------------------------------------------------------------------------------------------------
  // @ Private declaration vars
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  /** constructor  */
  // -----------------------------------------------------------------------------------------------------
  constructor(private _utilS: UtilsService) { }
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private valBrowser() {
    return {
      isIE: () => {
        return (
          window.navigator.userAgent.indexOf('MSIE') > 0 ||
          window.navigator.userAgent.indexOf('Trident/7.0') > 0
        );
      },
      isSafari: () => {
        return /Version\/[\d\.]+.*Safari/.test(navigator.userAgent);
      },
    };
  }

  /**
   * !transformBase64ToBlob
   * @param base64
   * @returns
   */
  private transformBase64ToBlob(base64) {
    var byteChars = atob(base64);
    var byteNumbers = new Array(byteChars.length);
    for (var i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var blobData = new Blob([byteArray], { type: 'application/pdf' });
    return blobData;
  }

  /**
   * ![dwnldPDF]
   * donwnload file PDF
   * from B64 string
   * @param dataB64File
   * @param nameFile
   */
  public dwnldPDF(dataB64File, nameFile: string = 'comprobante') {
    let fileName = nameFile ? nameFile + '.pdf' : 'reporte.pdf';
    this.dwnldAnyFileB64(dataB64File, 'application/pdf', fileName);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * !txtB64File
   * @param dataBase64
   * @param nameFile
   */
  txtB64File(dataBase64, nameFile) {
    let txtFileName = nameFile ? nameFile : 'reporte.txt';
    this.dwnldAnyFileB64(dataBase64, 'text/plain', txtFileName);
  }

  txtB64FileCDom(dataBase64: string, nameFile: string) {
    // Decode the base64 string
    let decodedString = atob(dataBase64);
    // Replace URL encoded characters with actual characters
    let decodedAndFormattedString = decodeURIComponent(decodedString);
    // Use the desired file name or default to 'reporte.txt'
    let txtFileName = nameFile ? nameFile : 'reporte.txt';

    // Call a function to handle the download of the file
    this.dwnldAnyFileB64(
      btoa(decodedAndFormattedString),
      'text/plain',
      txtFileName
    );
  }

  /**
   * !dwnldAnyFileB64
   * @param dataBase64 {string}
   * @param mimetype {string}
   * {byExmple} 'application/pdf'
   * {byExmple} 'text/xml'
   * @param nameFile {string}
   */
  dwnldAnyFileB64(dataBase64: string, mimetype: string, nameFile: string) {
    let appAndCode = 'data:' + mimetype + ';base64,',
      fileName = nameFile ? nameFile : 'archivo',
      base64EncodedPDF = appAndCode + dataBase64,
      dlnk = document.createElement('a');

    if (this.valBrowser().isIE()) {
      var blobData = this.transformBase64ToBlob(dataBase64);
      this.nav.msSaveBlob(blobData, fileName);
    } else if (this.valBrowser().isSafari()) {
      window.open(appAndCode + dataBase64);
    } else {
      dlnk.setAttribute('download', fileName);
      document.body.appendChild(dlnk);
      dlnk.href = base64EncodedPDF;
      dlnk.click();
      dlnk.remove();
    }
  }

  /**
   * ![dwnldPDF]
   * donwnload file CSV or TXT
   * from B64 string
   * @param dataB64File
   * @param nameFile
   */
  public dwnldTxtOrCsv(
    dataB64File,
    nameFile: string = 'comprobante',
    typeFile: any
  ) {
    let dataFileType = 'data:text/plain;base64,',
      base64EncodedPDF = dataFileType + dataB64File,
      dlnk = document.createElement('a');

    if (this.valBrowser().isIE()) {
      var blobData = this.transformBase64ToBlob(dataB64File);
      this.nav.msSaveBlob(blobData, nameFile);
    } else if (this.valBrowser().isSafari()) {
      window.open(dataFileType + dataB64File);
    } else {
      dlnk.setAttribute('download', nameFile + '.' + typeFile);
      document.body.appendChild(dlnk);
      dlnk.href = base64EncodedPDF;
      dlnk.click();
      dlnk.remove();
    }
  }

  /**
   * ![dwnldZIP]
   * donwnload file ZIP
   * from B64 string
   * @param dataB64File
   * @param nameFile
   */
  public dwnldZip(dataB64File, nameFile: string = 'reporte') {
    let dataFileType = 'data:application/zip;base64,',
      base64Encoded = dataFileType + dataB64File,
      dlnk = document.createElement('a');

    if (this.valBrowser().isIE()) {
      var blobData = this.transformBase64ToBlob(dataB64File);
      this.nav.msSaveBlob(blobData, nameFile);
    } else if (this.valBrowser().isSafari()) {
      window.open(dataFileType + dataB64File);
    } else {
      dlnk.setAttribute('download', nameFile + '.zip');
      document.body.appendChild(dlnk);
      dlnk.href = base64Encoded;
      dlnk.click();
      dlnk.remove();
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   *
   * @param objCSV  {object}
   *
   * @returns  void
   */
  public csvFile(objCSV: dwnldCSVType): void {
    let headerDocument = objCSV.headerDocument ? objCSV.headerDocument : [],
      tableHeader = objCSV.tableHeader ? objCSV.tableHeader : [],
      tableData = objCSV.tableData ? objCSV.tableData : [],
      fileName = objCSV.fileName ? objCSV.fileName : 'reporte',
      msgNote = objCSV.msgNote ? objCSV.msgNote : undefined,
      csvFile = '',
      EOL = '\r\n',
      BOM = '\ufeff',
      csvFileName =
        fileName + '.' + (objCSV.typeFile ? objCSV.typeFile : 'csv'),
      dataAndCharset = 'data:text/csv;charset=utf-8,';

    if (!headerDocument || !tableHeader || !tableData) {
      console.error(
        'Factory "dataForCSV": No se puede generar objeto. Error de datos faltantes.'
      );
      return;
    }

    let stringifyData = (data) => {
      if (typeof data === 'string') {
        if (data.indexOf(',') > -1) {
          data = '"' + data + '"';
        }
      } else {
        data = data + '';
      }
      return data;
    },
      stgFileDetail = () => {
        let csvDetail = '';
        if (headerDocument.length > 0) {
          for (let i = 0; i < headerDocument.length; i++) {
            csvDetail +=
              stringifyData(headerDocument[i].key) +
              ',' +
              stringifyData(headerDocument[i].value) +
              EOL;
          }
          csvDetail += EOL;
        }
        return csvDetail;
      },
      stgTableHeader = () => {
        let csvTableHeader = '';

        for (let i = 0; i < tableHeader.length; i++) {
          i == tableHeader.length - 1
            ? (csvTableHeader += stringifyData(tableHeader[i]))
            : (csvTableHeader += stringifyData(tableHeader[i]) + ',');
        }

        csvTableHeader += EOL;
        return csvTableHeader;
      },
      stgTableData = () => {
        let csvTableData = '';
        for (let i = 0; i < tableData.length; i++) {
          for (let property in tableData[i]) {
            if (tableData[i].hasOwnProperty(property)) {
              csvTableData += stringifyData(tableData[i][property]) + ',';
            }
          }
          csvTableData = csvTableData.slice(0, -1);
          csvTableData += EOL;
        }
        return csvTableData;
      },
      buildCSV = () => {
        csvFile += BOM;
        csvFile += stgFileDetail();
        if (tableHeader.length > 0) {
          csvFile += stgTableHeader();
        }
        csvFile += stgTableData();
        if (msgNote !== undefined && msgNote.length > 0) {
          csvFile += EOL;
          csvFile += msgNote;
        }
      },
      doClick = () => {
        if (this.valBrowser().isIE()) {
          let blob = new Blob([csvFile], { type: dataAndCharset });
          this.nav.msSaveBlob(blob, csvFileName);
        } else {
          let link = document.createElement('a');
          link.setAttribute(
            'href',
            dataAndCharset + encodeURIComponent(csvFile)
          );
          link.setAttribute('download', csvFileName);
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      };

    buildCSV();
    doClick();
  }


  /**
   * ![dataURLtoBlob]
   * @param dataURI
   * @param nameFile
   */
  dataURLtoBlob(dataURI, nameFile) {
    let request = new XMLHttpRequest();
    request.open('GET', dataURI, true);

    request.responseType = 'blob';
    request.onload = () => {
      let reader = new FileReader();
      reader.readAsDataURL(request.response);
      reader.onload = (e) => {
        let dataurl = (<string>e.target.result).split(','),
          mime = dataurl[0].match(/:(.*?);/)[1],
          blobStr = dataurl[1];
        this.dwnldAnyFileB64(blobStr, mime, nameFile);
      };
    };
    request.send();
  }

  /**
   * Genera un reporte en formato PDF utilizando `jsPDF` y `autoTable`.
   *
   * @param {dwnldPDFType} objPDF - Objeto que contiene la información necesaria para generar el PDF. Las propiedades esperadas son:
   *  - infoComprobante: {Object} - Información del comprobante, como título y tablas.
   *  - tablasComprobante: {Array} - Arreglo que contiene la información tabular del reporte.
   *    - columnas: {Array} - Arreglo de columnas que define el encabezado de la tabla.
   *    - filas: {Array} - Arreglo de filas que contiene los datos de la tabla.
   *    - estilos: {Object} [Opcional] - Estilos personalizados para las columnas utilizando `columnStyles` de `autoTable`.
   *      - Ejemplo: `{ 0: { halign: 'center' }, 1: { halign: 'right' }, 2: { halign: 'left', fontStyle: 'bold' } }`.
   *  - nombrePdfOpcional: {string} [Opcional] - Nombre personalizado para el archivo PDF. Por defecto, 'reporte.pdf'.
   *  - orientation: {string} [Opcional] - Orientación del PDF ('p' para vertical, 'l' para horizontal). Valor por defecto: 'p'.
   *  - unit: {string} [Opcional] - Unidad de medida del PDF. Valor por defecto: 'pt'.
   *  - customHeader: {boolean} [Opcional] - Booleano que indica si se utiliza un encabezado personalizado. Por defecto: false.
   *
   * @returns {void} - El archivo PDF generado se guarda con el nombre especificado o 'reporte.pdf' por defecto.
   *
   * @throws {Error} - Se lanzan errores en consola si faltan datos necesarios o si los formatos de los datos no son válidos.
   *
   */
  public pdfAutotable(objPDF: dwnldPDFType): void {

    let infoComprobante = objPDF.infoComprobante
      ? objPDF.infoComprobante
      : undefined,
      tablasComprobante = objPDF.tablasComprobante
        ? objPDF.tablasComprobante
        : undefined,
      nombrePdfOpcional = infoComprobante.nombrePdfOpcional
        ? infoComprobante.nombrePdfOpcional
        : 'reporte.pdf',
      orientation = objPDF.orientation ? objPDF.orientation : 'p',
      unit = objPDF.unit ? objPDF.unit : 'pt',
      customHeader = objPDF.customHeader ? objPDF.customHeader : false;

    const isMovimientos =
      infoComprobante?.tituloComprobante?.[0] === 'Movimientos';

    if (!infoComprobante || !tablasComprobante) {
      console.error(
        'Factory "pdfAutotable": No se puede generar el reporte. Error de datos faltantes.'
      );
      return;
    }

    if (!infoComprobante.tituloComprobante) {
      console.error(
        'Factory "pdfAutotable": No se puede generar el reporte. Error de datos faltantes.'
      );
      return;
    }

    if (
      Object.prototype.toString.call(infoComprobante) !== '[object Object]' ||
      Object.prototype.toString.call(tablasComprobante) !== '[object Array]' ||
      Object.prototype.toString.call(infoComprobante.tituloComprobante) !==
      '[object Array]'
    ) {
      console.error(
        'Factory "pdfAutotable": No se puede generar el reporte. Error en formato de datos.'
      );
      return;
    }

    if (tablasComprobante[0]) {
      if (tablasComprobante[0].columnas) {
        if (tablasComprobante[0].columnas.length > 6) {
          orientation = 'l';
        }
      }
    }
    const doc = new jsPDF(orientation, unit, 'letter');

    let centeredText = function (text, y) {
      var textWidth =
        //(doc.getStringUnitWidth(text) * doc.getFontSize() doc.internal.getFontSize()) /
        (doc.getStringUnitWidth(text) * doc.getFontSize()) /
        doc.internal.scaleFactor;
      var textOffset = (doc.internal.pageSize.getWidth() - textWidth) / 2;
      doc.text(text, textOffset, y);
    };

    //let tituloHeaderComprobante = customHeader ? infoComprobante.customHeader : infoComprobante.tituloComprobante;

    var headerImgData = vGlobal.headerImgData


    /** LOGO BX+ */
    doc.addImage(headerImgData, 'JPEG', 40, 40, 100, 35);
    autoTable(doc, {
      startY: 80,
      head: [[infoComprobante.tituloComprobante]],
      headStyles: {
        fillColor: [184, 200, 44],
        textColor: [44, 59, 70],
        halign: 'center',
        fontStyle: 'bold',
        fontSize: 14,
      },
    });

    // Tabla informativa cliente
    if (customHeader) {
      autoTable(doc, {
        startY: 100,
        body: infoComprobante.customBody,
      });
    }

    // tabla datos
    autoTable(doc, {
      startY: customHeader ? 190 : 130,
      didDrawPage: (data) => {
        var top = orientation != 'p' ? 580 : 770,
          line = 10;

        doc.setFontSize(8);
        doc.setFont('helvetica', 'bolditalic');
        //doc.setFontStyle('bolditalic');
        doc.setTextColor(40);
        // Si es horizontal el pie de pagina va a la izq, else va centrado
        centeredText(vGlobal.footeReport[0], top);
        centeredText(vGlobal.footeReport[1], top + line);
      },

      headStyles: {
        fillColor: [200, 205, 204],
        textColor: [44, 59, 70],
        halign: 'center',
        fontStyle: 'bold',
        fontSize: isMovimientos ? 10 : 12,
      },
      styles: {
        cellPadding: 5,
        fontSize: isMovimientos ? 8 : 10,
        lineColor: 200,
        lineWidth: 0,
        fontStyle: 'normal',
        textColor: [52, 62, 72],
        halign: 'center',
        valign: 'middle',
        overflow: 'linebreak',
      },
      columnStyles: tablasComprobante[0].estilos
        ? tablasComprobante[0].estilos
        : { 0: { halign: 'center' } },
      body: tablasComprobante[0].filas,
      columns: tablasComprobante[0].columnas,
    });

    nombrePdfOpcional =
      typeof nombrePdfOpcional === 'undefined' || nombrePdfOpcional === ''
        ? 'reporte.pdf'
        : nombrePdfOpcional;

    doc.save(nombrePdfOpcional);
  }

  /**
   * !generateLegalPdf
   * @param title 
   * @param bodyText 
   */
  public generateLegalPdf(title: string, bodyText: string): void {
    const doc = new jsPDF('p', 'pt', 'letter');

    // Función para centrar texto
    const centeredText = (text: string, y: number) => {
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.getFontSize()) /
        doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.getWidth() - textWidth) / 2;
      doc.text(text, textOffset, y);
    };


    const margin = 40;
    const lineHeight = 16;
    const maxLineWidth = doc.internal.pageSize.getWidth() - margin * 2;
    let y = 80;

    var headerImgData = vGlobal.headerImgData

    doc.addImage(headerImgData, 'JPEG', margin, 40, 100, 35);

    // Título centrado
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    const titleLines = doc.splitTextToSize(title, maxLineWidth);
    titleLines.forEach((line) => {
      const textWidth = doc.getTextWidth(line);
      const textOffset = (doc.internal.pageSize.getWidth() - textWidth) / 2;
      doc.text(line, textOffset, y);
      y += lineHeight;
    });

    // Contenido del Addendum (como párrafos)
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    const paragraphs = bodyText.split('\n');

    paragraphs.forEach((p) => {
      const lines = doc.splitTextToSize(p.trim(), maxLineWidth);
      if (
        y + lines.length * lineHeight >
        doc.internal.pageSize.getHeight() - margin
      ) {
        doc.addPage();
        y = margin;
      }
      doc.text(lines, margin, y);
      y += lines.length * lineHeight;
    });

    // Pie de página
    const footerY = doc.internal.pageSize.getHeight() - 30;

    const footer = () => {
      const top = 770;
      const line = 10;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bolditalic');
      doc.setTextColor(40);
      centeredText(vGlobal.footeReport[0], top);
      centeredText(vGlobal.footeReport[1], top + line);
    };

    // Aplicar pie de página
    footer();

    doc.save(`${title}.pdf`);
  }

  /**
   * Genera un reporte en formato PDF con múltiples tablas utilizando `jsPDF` y `autoTable`.
   *
   * @param {dwnldPDFType} objPDF - Objeto que contiene la información necesaria para generar el PDF. Las propiedades esperadas son:
   *  - infoComprobante: {Object} - Información del comprobante, como título y tablas.
   *    - tituloComprobante: {string} - Título principal del comprobante.
   *    - nombrePdfOpcional: {string} [Opcional] - Nombre personalizado para el archivo PDF. Por defecto, 'reporte.pdf'.
   *  - tablasComprobante: {Array} - Arreglo que contiene la información tabular del reporte.
   *    - columnas: {Array} - Arreglo de columnas que define el encabezado de la tabla. Cada objeto debe incluir:
   *      - header: {string} - Encabezado de la columna.
   *      - key: {string} - Clave para mapear los datos de las filas.
   *    - filas: {Array} - Arreglo de objetos que contiene los datos de las filas. Cada objeto debe tener claves que coincidan con las columnas.
   *    - estilos: {Object} [Opcional] - Estilos personalizados para las columnas utilizando `columnStyles` de `autoTable`.
   *      - Ejemplo: `{ 0: { halign: 'center' }, 1: { halign: 'right' }, 2: { halign: 'left', fontStyle: 'bold' } }`.
   *    - tituloTabla: {string} [Opcional] - Título individual de cada tabla.
   *  - orientation: {string} [Opcional] - Orientación del PDF ('p' para vertical, 'l' para horizontal). Valor por defecto: 'p'.
   *  - unit: {string} [Opcional] - Unidad de medida del PDF. Valor por defecto: 'pt'.
   *  - customHeader: {boolean} [Opcional] - Booleano que indica si se utiliza un encabezado personalizado. Por defecto: false.
   *
   * @returns {void} - El archivo PDF generado se guarda con el nombre especificado o 'reporte.pdf' por defecto.
   *
   * @throws {Error} - Se lanzan errores en consola si faltan datos necesarios o si los formatos de los datos no son válidos.
   */

  public pdfAutotableMultiple(objPDF: dwnldPDFType): void {
    const infoComprobante = objPDF.infoComprobante
      ? objPDF.infoComprobante
      : undefined,
      tablasComprobante = objPDF.tablasComprobante
        ? objPDF.tablasComprobante
        : undefined,
      nombrePdfOpcional = infoComprobante.nombrePdfOpcional
        ? infoComprobante.nombrePdfOpcional
        : 'reporte.pdf',
      orientation = objPDF.orientation ? objPDF.orientation : 'p',
      unit = objPDF.unit ? objPDF.unit : 'pt',
      customHeader = objPDF.customHeader ? objPDF.customHeader : false,
      customLogoData = objPDF.customLogoData ? objPDF.customLogoData : null,
      aditionalText = objPDF.aditionalText ? objPDF.aditionalText : null,
      aditionalFooterText = objPDF.aditionalFooterText || null;

    const tableFontSizes = objPDF.tableFontSizes ?? {};
    const DEFAULT_HEAD_FONT = 10;

    // Si llegan valores, úsalos; si no, respeta defaults actuales
    const resolvedHeadFont = tableFontSizes.header ?? DEFAULT_HEAD_FONT;

    if (!infoComprobante || !tablasComprobante) {
      console.error(
        'Factory "pdfAutotable": No se puede generar el reporte. Error de datos faltantes.'
      );
      return;
    }

    if (!infoComprobante.tituloComprobante) {
      console.error(
        'Factory "pdfAutotable": No se puede generar el reporte. Error de datos faltantes.'
      );
      return;
    }

    const doc = new jsPDF(orientation, unit, 'letter');

    // Función para centrar texto
    const centeredText = (text: string, y: number) => {
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.getFontSize()) /
        doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.getWidth() - textWidth) / 2;
      doc.text(text, textOffset, y);
    };

    var headerImgData = vGlobal.headerImgData

    /** LOGO BX+ */
    doc.addImage(headerImgData, 'JPEG', 40, 40, 100, 35);

    if (objPDF.customLogoData) {
      const logoTextX = orientation === 'l' ? 550 : 365;
      let currentY = 50;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(0);

      if (objPDF.customLogoData.line1) {
        doc.text(objPDF.customLogoData.line1, logoTextX, currentY);
        currentY += 10;
      }

      if (objPDF.customLogoData.line2) {
        doc.text(objPDF.customLogoData.line2, logoTextX, currentY);
        currentY += 10;
      }

      if (objPDF.customLogoData.line3) {
        doc.text(objPDF.customLogoData.line3, logoTextX, currentY);
      }
    }

    if (aditionalText) {
      const textX = 40;
      let currentY = 140;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(0);

      // Concatenar las líneas si es un objeto
      const textToRender =
        (typeof aditionalText === 'object')
          ?
          ((aditionalText.line3) ?
            `${aditionalText.line1 || ''}\n${aditionalText.line2 || ''} \n${aditionalText.line3 || ''}` :
            `${aditionalText.line1 || ''}\n${aditionalText.line2 || ''}`)
          : aditionalText;

      const textLines = doc.splitTextToSize(textToRender, 500);
      textLines.forEach((line) => {
        doc.text(line, textX, currentY);
        currentY += 10;
      });
    }

    // Ajustar contenido de la primera página
    autoTable(doc, {
      startY: 180,
      head: [[infoComprobante.tituloComprobante]],
      headStyles: {
        fillColor: [184, 200, 44],
        textColor: [44, 59, 70],
        halign: 'center',
        fontStyle: 'bold',
        fontSize: 14,
      },
    });

    // Iterar sobre las tablas y renderizarlas en páginas separadas
    tablasComprobante.forEach((tabla, index) => {
      // Agregar una nueva página si no es la primera tabla
      if (index > 0) {
        doc.addPage();
      }

      // Agregar título de la tabla
      if (tabla.tituloTabla) {
        doc.setFontSize(14);
        doc.setTextColor(0);
        doc.text(tabla.tituloTabla, 40, 90); // Ajusta la posición del título
      }

      // Dibujar la tabla con encabezados y datos
      autoTable(doc, {
        startY: index === 0 ? 205 : 100, // La primera tabla tiene un margen superior mayor
        head: [tabla.columnas.map((col) => col.header)], // Encabezados únicos
        body: tabla.filas.map(
          (fila) => tabla.columnas.map((col) => fila[col.key] || '') // Mapea los datos de cada fila según la clave
        ),
        headStyles: {
          fillColor: [200, 205, 204],
          textColor: [44, 59, 70],
          halign: 'center',
          fontStyle: 'bold',
          fontSize: resolvedHeadFont,
        },
        styles: {
          cellPadding: 5,
          fontSize: 10,
          lineColor: 200,
          lineWidth: 0,
          fontStyle: 'normal',
          textColor: [52, 62, 72],
          halign: 'center',
          valign: 'middle',
          overflow: 'linebreak',
        },
        columnStyles: tabla.estilos
          ? tabla.estilos
          : { 0: { halign: 'center' } },
      });
    });

    if (aditionalFooterText) {
      const textX = 40;
      let currentY = 280;

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(0);

      const textLines = doc.splitTextToSize(aditionalFooterText, 500);
      textLines.forEach((line) => {
        doc.text(line, textX, currentY);
        currentY += 10;
      });
    }

    // Pie de página común para todas las páginas
    const footer = () => {
      const top = orientation !== 'p' ? 580 : 770;
      const line = 10;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bolditalic');
      doc.setTextColor(40);
      centeredText(vGlobal.footeReport[0], top);
      centeredText(vGlobal.footeReport[1], top + line);
    };

    // Aplicar pie de página
    footer();

    // Guardar el archivo PDF
    doc.save(nombrePdfOpcional || 'reporte.pdf');
  }

  pdfMultipleFormattedReport(objPDF: dwnldPDFType): void {
    const infoComprobante = objPDF.infoComprobante;
    const tablasComprobante = objPDF.tablasComprobante;

    if (!infoComprobante || !tablasComprobante) {
      console.error('No se puede generar el reporte. Faltan datos.');
      return;
    }

    const doc = new jsPDF('l', 'pt', 'letter');

    // Logo BX+ base64
    var headerImgData = vGlobal.headerImgData

    // Centrar texto utilitario
    const centeredText = (text: string, y: number) => {
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.getFontSize()) /
        doc.internal.scaleFactor;
      const textOffset = (doc.internal.pageSize.getWidth() - textWidth) / 2;
      doc.text(text, textOffset, y);
    };

    // Logo
    doc.addImage(headerImgData, 'JPEG', 40, 40, 100, 35);

    // Encabezado verde
    doc.setFillColor(184, 200, 44);
    doc.rect(40, 140, doc.internal.pageSize.getWidth() - 80, 30, 'F');
    doc.setFontSize(12);
    doc.setTextColor(44, 59, 70);
    doc.setFont('helvetica', 'bold');
    centeredText(infoComprobante.tituloComprobante[0], 160);

    // Subtítulo "Posición Inicial"
    if (tablasComprobante[0]?.tituloTabla) {
      doc.setFontSize(13);
      doc.setTextColor(0);
      doc.setFont('helvetica', 'normal');
      doc.text(tablasComprobante[0].tituloTabla, 40, 190);
    }

    // Tablas
    tablasComprobante.forEach((tabla, index) => {
      if (index > 0) doc.addPage();

      if (index > 0 && tabla.tituloTabla) {
        doc.setFontSize(13);
        doc.setTextColor(0);
        doc.text(tabla.tituloTabla, 40, 90);
      }

      autoTable(doc, {
        startY: index === 0 ? 210 : 100,
        head: [tabla.columnas.map((col) => col.header)],
        body: tabla.filas.map((fila) =>
          tabla.columnas.map((col) => fila[col.key] || '')
        ),
        headStyles: {
          fillColor: [200, 205, 204],
          textColor: [44, 59, 70],
          halign: 'center',
          fontStyle: 'bold',
          fontSize: 9,
        },
        styles: {
          cellPadding: 2,
          fontSize: 7,
          textColor: [52, 62, 72],
          halign: 'center',
          valign: 'middle',
          overflow: 'linebreak',
        },
        columnStyles: tabla.columnas.reduce((acc, _, idx) => {
          acc[idx] = { cellWidth: 'wrap' };
          return acc;
        }, {}),
        margin: { left: 40, right: 40 },
      });
    });

    // Pie común
    const footer = () => {
      const top = 570;
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bolditalic');
      doc.setTextColor(40);
      centeredText(vGlobal.footeReport[0], top);
      centeredText(vGlobal.footeReport[1], top + 10);
    };
    footer();

    // Guardar
    const nombre =
      infoComprobante?.nombrePdfOpcional?.[0] || 'reporte_formateado.pdf';
    doc.save(nombre);
  }


  /**
   * [downloadTxtReport description]
   * @param {any[]} data [description]
   * @param {string[]} headers [description]
   * @param {number[]} columnWidths [description]
   * @param {string} fileName [description]
   * */
  downloadTxtReport(
    data: any[],
    headers: string[],
    columnWidths: number[],
    fileName: string
  ) {
    const pad = (str: string, width: number) => {
      return str.padEnd(width, ' ');
    };

    let txtContent =
      columnWidths.map((width, i) => pad(headers[i], width)).join('') + '\n';

    data.forEach((row) => {
      txtContent +=
        [
          pad(row.folio.toString(), columnWidths[0]),
          pad(row.nombreArchivo, columnWidths[1]),
          pad(row.usuario, columnWidths[2]),
          pad(row.cantidadRegistros.toString(), columnWidths[3]),
          pad(row.fechaOperacion, columnWidths[4]),
          pad(row.horaOperacion, columnWidths[5]),
          pad(row.estatus, columnWidths[6]),
          pad(row.fechaProcesamiento || '', columnWidths[7]),
        ].join('') + '\n';
    });

    const base64TxtContent = btoa(txtContent);
    this.dwnldAnyFileB64(base64TxtContent, 'text/plain', fileName);
  }
}
